<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
      :customSub="true"
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {getDepartmentAllList} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orgIdOptions: [], // 适用部门
        form: [
          {
            label: '路径名称',
            value: 'pathName',
            type: 'input',
            placeholder: '请输入路径名称',
          },
          // {
          //   label: '有效时间',
          //   value: 'DependTime',
          //   type: 'date',
          //   placeholder: '请选择有效时间',
          //   attr: {
          //     type: 'datetimerange',
          //   },
          // },
          {
            label: '适用部门',
            value: 'orgId',
            type: 'select',
            default: [],
            placeholder: '请选择适用部门',
          },
        ],
      },
    };
  },
  // watch: {
  //   '$route': function (val) {
  //     if (this.$route.path === '/manage/operate/track/pathPlanning') {
  //       this.$refs.searchBox.sub();
  //     }
  //   }
  // },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // if (searchBoxData.DependTime && searchBoxData.DependTime.length > 0) {
      //   searchBoxData.startDate = this.formatDate(searchBoxData.DependTime[0], 1);
      //   searchBoxData.endDate = this.formatDate(searchBoxData.DependTime[1], 1);
      // }
      // delete searchBoxData.DependTime;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
